import { FC } from "react";
import { CheckboxCard, Radio } from "shared/components";
import { DiscountCode } from "../types";
import {
  formatDiscountDateRange,
  formatDiscountValue
} from "../utils/discountCalculations";

interface DiscountRadioCardProps {
  discount: DiscountCode;
  checked: boolean;
  onSelect: (discount: DiscountCode) => void;
  name: string;
}

export const DiscountRadioCard: FC<DiscountRadioCardProps> = ({
  discount,
  checked,
  onSelect,
  name
}) => {
  return (
    <CheckboxCard
      id={`discount-${discount.id}`}
      name={name}
      checked={checked}
      onChange={() => onSelect(discount)}
      label={
        <div className="flex items-center justify-between w-full py-1 px-2">
          <Radio
            id={`inner-discount-${discount.id}`}
            name={name}
            checked={checked}
            onChange={() => onSelect(discount)}
            label={discount.code}
            subLabelText={formatDiscountDateRange(discount)}
            className="items-center gap-4"
          />
          <span className="text-sm font-medium text-content-1000">
            {formatDiscountValue(discount)}
          </span>
        </div>
      }
    />
  );
};
